import React from "react";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/Breadcrumb";
import SearchProduct from "../../components/product/SearchProduct";
import FooterOne from "../../components/layout/FooterOne";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import BottomFooter from "../../components/layout/BottomFooter";

const SearchProductPage = () => {

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#990A02" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      {/* <HeaderOne /> */}
      <HeaderHome />

      {/* Breadcrumb */}
      <Breadcrumb title={"Search Products"} />

      {/* SearchProduct */}
      <SearchProduct />

      {/* ShippingTwo */}
      {/* <ShippingTwo /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />

    </>
  );
};

export default SearchProductPage;
